import { charts } from "@/api/reports.api";
import shared from "@lab/store/report.requests.module";

const state = {
	...shared.state
};

const getters = { ...shared.getters };
const actions = {
	...shared.actions,
	async fetch({ commit, dispatch, getters }, source) {
		if (getters.cancelTokens.length) {
			dispatch("cancelRequests");
		}

		const response = await charts.fetch(source);
		return response;
	},
	async fetchApex({ commit, dispatch, getters }, source) {
		if (getters.cancelTokens.length) {
			dispatch("cancelRequests");
		}

		const response = await charts.apexdata(source);
		return response;
	}
};
const mutations = {
	...shared.mutations
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};
